import { Box, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      height: '100%',
      padding: 24,
    },
  })
);

interface PermissionGuardProps {
  allowed: boolean;
  children: React.ReactNode;
}

export default function PermissionGuard({
  allowed,
  children,
}: PermissionGuardProps) {
  const classes = useStyles();

  if (!allowed) {
    return (
      <Box className={classes.root}>
        <Typography variant='h5' gutterBottom>
          Access denied
        </Typography>
        <Typography variant='body1' color='textSecondary'>
          You do not have permission to access this page.
        </Typography>
      </Box>
    );
  }

  return <>{children}</>;
}
